'use strict';

const Translations = require('../translations');

const internals = {};

internals.format = (obj) => {

    return Object.entries(obj).map(([value, label]) => {

        return {
            value,
            label
        };
    });
};

module.exports = {
    list: (translation, format = false) => {

        const translated = Translations[translation] || Translations.en;

        return format ? internals.format(translated) : translated;
    },
    get: (language, translation, format = false) => {

        const translated = (Translations[translation] && Translations[translation][language]) ? Translations[translation][language] : Translations.en[language];

        if (format) {

            return { value: language, label: translated };
        }

        return translated;
    },
    filter: (list = [], translation, format = false) => {

        return list.map((value) => module.exports.get(value, translation, format));
    },
    languages: () => {

        return Object.keys(Translations.en);
    }
};
